import React, { useContext } from "react"

import HeroModule from "@modules/HeroModule"
import { useTranslation } from "gatsby-plugin-react-i18next"
import LanguageContext from "@context/LanguageContext"
import { useRedirectToPro } from "@hooks/siteURLs"
import { CONTACT_FORM_URL } from "@constants/index"

export default () => {
  const { t } = useTranslation()

  const context = useContext(LanguageContext)
  const urlPro = useRedirectToPro()

  let heroParams = {
    motto: t("Home_Hero_H2_1"),
    backgroundImage: "home_cover.png",
    video: true,
    theme: "white-bg",
    cta1text: t("Home_Hero_Button1"),
    cta2text: t("Home_Hero_Button2"),
    largeText: "",
    useButton1Navigate: false,
    button1LinkTag: "link",
    button2LinkTag: "link",
    dataEvent1: {
      id: "Pro Form All",
      triggers: "SellNow",
      source: "ContactPage",
    },
    dataEvent2: {
      id: "Appointment All",
      triggers: "ScheduleACall",
      source: "ContactPage",
      contact: "Patrick",
    },
    button1Url: urlPro,
    button2Url: CONTACT_FORM_URL,
    smExtraClassName:
      "px-6 !pb-12.5 border-b-0.5 border-opacity-30 border-g70 !text-dblue ",
    bgClasses: "!h-[150px] md:!h-[350px] desk:!h-[450px] !bgcover",
    largeTextClasses: "hidden",
  }

  return <HeroModule {...{ ...heroParams, ...{ background: "bg-dblue" } }} />
}
